import { useSelector } from 'react-redux';

import store from 'src/store';

import jira from 'src/lib/api/jira';

import { fatalError, onModalClosed } from './actions';

type JiraContext = {
  loading: boolean,
  context: ?{},
  settings: ?{},
  session: ?{},
  error: ?any,
};

export const useJiraContext = () : JiraContext => useSelector(state => state.jira);
export const getJiraContext = () => store.getState().jira;

export const openDialog = (url, { width, height, minHeight, onClose }) => {
  jira
    .openModal(url, { width, height, minHeight })
    .then(() => {
      store.dispatch(onModalClosed(url));
      if (onClose) onClose();
    })
    .catch((e) => store.dispatch(fatalError(['Failed to open modal dialog', e])));
};

export const closeDialog = () => {
  jira.closeCurrentModal();
};
